import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

export const PAGE_SIZES = [25, 50, 100, 200];

export default function Pager({ page, size, total, onPage, onSize }) {
  const pages = Math.max(1, Math.ceil(total / size));
  const from = total ? page * size + 1 : 0;
  const to = Math.min(total, (page + 1) * size);
  const nums = [...new Set([0, page - 1, page, page + 1, pages - 1])].filter((n) => n >= 0 && n < pages).sort((a, b) => a - b);
  const b = "p-1.5 rounded hover:bg-[var(--hover)] disabled:opacity-30 disabled:hover:bg-transparent";
  return (
    <div className="panel rounded-b-lg border-t-0 flex flex-wrap items-center gap-3 px-4 py-2.5 text-sm" data-testid="crm-pager">
      <label className="flex items-center gap-2 text-[var(--text-dim)] text-xs">Records per page
        <select className="px-2 py-1 rounded border text-xs" value={size} onChange={(e) => onSize(Number(e.target.value))} data-testid="pager-size">
          {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>
      <span className="text-xs text-[var(--text-dim)]" data-testid="pager-range"><b className="text-[var(--text)]">{from}–{to}</b> of {total}</span>
      <div className="ml-auto flex items-center gap-0.5">
        <button className={b} disabled={page === 0} onClick={() => onPage(0)} data-testid="pager-first"><ChevronsLeft size={15} /></button>
        <button className={b} disabled={page === 0} onClick={() => onPage(page - 1)} data-testid="pager-prev"><ChevronLeft size={15} /></button>
        {nums.map((n, i) => (
          <span key={n} className="flex items-center">
            {i > 0 && n - nums[i - 1] > 1 && <span className="px-1 text-[var(--text-faint)]">…</span>}
            <button onClick={() => onPage(n)} data-testid={`pager-page-${n + 1}`}
              className={`min-w-[30px] h-[30px] rounded text-xs ${n === page ? "bg-[var(--ai)] font-semibold" : "hover:bg-[var(--hover)] text-[var(--text-dim)]"}`} style={n === page ? { color: "#fff" } : undefined}>{n + 1}</button>
          </span>
        ))}
        <button className={b} disabled={page >= pages - 1} onClick={() => onPage(page + 1)} data-testid="pager-next"><ChevronRight size={15} /></button>
        <button className={b} disabled={page >= pages - 1} onClick={() => onPage(pages - 1)} data-testid="pager-last"><ChevronsRight size={15} /></button>
      </div>
    </div>
  );
}
